module.exports = __webpack_public_path__ + "img/6f545b8.jpg";